/* eslint-disable */
<template>
  <div class="pay-page">

    <div class="page-body">

      <!-- ══════════════════════════════════════════
           SUCCESS SCREEN
      ══════════════════════════════════════════ -->
      <div v-if="screen === 'success'" class="form-card status-card">
        <div class="status-icon success-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
          </svg>
        </div>
        <h1 class="status-title">Payment Successful!</h1>
        <p class="status-subtitle">ගෙවීම සාර්ථකව සිදු විය</p>

        <div class="receipt-summary">
          <div class="rs-row"><span class="rs-label">Invoice No.</span><span class="rs-val bold">{{ result.invoiceNumber }}</span></div>
          <div class="rs-row"><span class="rs-label">Account No.</span><span class="rs-val">{{ result.accountNumber }}</span></div>
          <div class="rs-row"><span class="rs-label">Amount Paid</span><span class="rs-val success-text bold">LKR {{ formatCurrency(result.paymentAmount) }}</span></div>
          <div v-if="result.remainingBalance !== null" class="rs-row">
            <span class="rs-label">Remaining Balance</span>
            <span class="rs-val">LKR {{ formatCurrency(result.remainingBalance) }}</span>
          </div>
        </div>

        <div class="sms-note">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
          </svg>
          An SMS confirmation has been sent to your registered mobile number.
        </div>

        <div class="action-stack">
          <button @click="viewReceipt" class="btn-primary-action w-100">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
            View &amp; Print Receipt
          </button>
          <button @click="payAnother" class="btn-outline-action w-100">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
            </svg>
            Pay Another Bill
          </button>
        </div>
      </div>

      <!-- ══════════════════════════════════════════
           FAILED SCREEN
      ══════════════════════════════════════════ -->
      <div v-else-if="screen === 'failed'" class="form-card status-card">
        <div class="status-icon fail-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </div>
        <h1 class="status-title">Payment Failed</h1>
        <p class="status-subtitle">ගෙවීම ව්‍යර්ථ විය</p>

        <div v-if="result.errorMsg" class="error-banner">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
          </svg>
          {{ result.errorMsg }}
        </div>

        <div class="action-stack">
          <button @click="tryAgain" class="btn-primary-action w-100">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
            </svg>
            Try Again
          </button>
          <button @click="payAnother" class="btn-outline-action w-100">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
            </svg>
            Back to Home
          </button>
        </div>
      </div>

      <!-- ══════════════════════════════════════════
           MAIN PAYMENT CARD
      ══════════════════════════════════════════ -->
      <div v-else>

        <!-- Page Header -->
        <div class="page-header">
          <div class="header-left">
            <div class="header-bar"></div>
            <div>
              <p class="breadcrumb-label">Water Bill | ජල බිල්පත</p>
              <h1 class="page-title">Safe &amp; Easy Pay</h1>
              <p class="page-subtitle">Account: {{ accountDetails.accountNumber }}</p>
            </div>
          </div>
        </div>

        <!-- Total Due -->
        <div class="form-card total-due-card">
          <span class="due-label">Total Due Amount</span>
          <h1 class="due-amount">LKR {{ formatCurrency(accountDetails.totalOutstanding) }}</h1>
        </div>

        <!-- Bill Info -->
        <div class="form-card">
          <div class="card-header">
            <div class="step-badge">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
            </div>
            <div>
              <h2 class="card-title">Usage Summary</h2>
              <p class="card-desc">Your latest billing details</p>
            </div>
          </div>

          <div class="detail-grid">
            <div class="detail-item">
              <span class="detail-label">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
                Billing Date
              </span>
              <span class="detail-value">{{ accountDetails.billingDate || 'N/A' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                Service Period
              </span>
              <span class="detail-value small-text">{{ accountDetails.period }}</span>
            </div>
          </div>

          <!-- Readings -->
          <div class="readings-row">
            <div class="reading-item">
              <span class="detail-label">Previous</span>
              <span class="detail-value">{{ accountDetails.readings.previous }}</span>
            </div>
            <div class="reading-divider"></div>
            <div class="reading-item">
              <span class="detail-label">Current</span>
              <span class="detail-value">{{ accountDetails.readings.current }}</span>
            </div>
            <div class="reading-divider main"></div>
            <div class="reading-item highlight">
              <span class="detail-label">Units Consumed</span>
              <span class="detail-value consumed">{{ accountDetails.readings.consumed }}</span>
            </div>
          </div>
        </div>

        <!-- Amount Input -->
        <div class="form-card">
          <div class="card-header">
            <div class="step-badge">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
            </div>
            <div>
              <h2 class="card-title">Payment Amount</h2>
              <p class="card-desc">How much would you like to pay?</p>
            </div>
          </div>

          <div class="amount-input-wrap">
            <span class="currency-tag">LKR</span>
            <input
              type="number"
              class="amount-input"
              v-model.number="enteredPaymentAmount"
              @input="autoDistributePayment"
              placeholder="0.00"
              :disabled="checkoutStarted"
            />
          </div>

          <!-- Breakdown -->
          <div v-if="enteredPaymentAmount > 0" class="breakdown-box">
            <p class="breakdown-title">Automatic Allocation</p>
            <div class="allocation-grid">
              <div class="alloc-item">
                <span class="alloc-label">Fines</span>
                <span class="alloc-val fine-text">{{ formatCurrency(breakdownInputs.fine) }}</span>
              </div>
              <div class="alloc-item">
                <span class="alloc-label">Arrears</span>
                <span class="alloc-val arrears-text">{{ formatCurrency(breakdownInputs.arrears) }}</span>
              </div>
              <div class="alloc-item no-border">
                <span class="alloc-label">Current Bill</span>
                <span class="alloc-val success-text">{{ formatCurrency(breakdownInputs.current) }}</span>
              </div>
            </div>
            <div v-if="breakdownInputs.excess > 0" class="excess-pill">
              <span>Balance for future bills:</span>
              <strong>LKR {{ formatCurrency(breakdownInputs.excess) }}</strong>
            </div>
          </div>

          <!-- Proceed -->
          <button
            v-if="!checkoutStarted"
            @click="startCheckout"
            class="submit-btn w-100"
            :disabled="enteredPaymentAmount <= 0 || isSubmitting"
          >
            Proceed to Checkout
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
            </svg>
          </button>
        </div>

        <!-- ════════════════════════════════
             CHECKOUT CONFIRMATION PANEL
        ════════════════════════════════ -->
        <div v-if="checkoutStarted && screen === 'confirm'" class="form-card">
          <div class="card-header">
            <div class="step-badge">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div class="confirm-header-flex">
              <div>
                <h2 class="card-title">Confirm &amp; Pay</h2>
                <p class="card-desc">Amount is locked for this session.</p>
              </div>
              <button type="button" class="edit-amount-btn" @click="resetCheckout" :disabled="isSubmitting">
                Change Amount
              </button>
            </div>
          </div>

          <!-- Amount Summary -->
          <div class="summary-section">
            <div class="summary-row">
              <span class="summary-label">Bill Amount</span>
              <span class="summary-value">LKR {{ formatCurrency(lockedPaymentAmount) }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Bank Service Charge (1%)</span>
              <span class="summary-value muted">LKR {{ formatCurrency(bankFee) }}</span>
            </div>
            <div class="summary-row grand-total-row">
              <span class="summary-label">Grand Total Payable</span>
              <span class="summary-value grand-total-value">LKR {{ formatCurrency(grandTotal) }}</span>
            </div>
          </div>

          <!-- Certify -->
          <label class="certify-label" :class="{ checked: certified }">
            <div class="custom-checkbox" :class="{ checked: certified }" @click="certified = !certified">
              <svg v-if="certified" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/>
              </svg>
            </div>
            <span class="certify-text">
              I confirm the above details are correct and authorise this payment.<br>
              <em>ඉහත තොරතුරු නිවැරදි බවටත්, මෙම ගෙවීම අනුමත කරන බවටත් සහතික කරමි.</em>
            </span>
          </label>

          <!-- Error -->
          <div v-if="payError" class="error-banner">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
            {{ payError }}
          </div>

          <!-- Initiate -->
          <button
            @click="initiateAndShowGateway"
            class="pay-now-btn w-100"
            :disabled="!certified || isSubmitting"
          >
            <span v-if="isSubmitting" class="loading-text">
              <svg class="spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Preparing Payment...
            </span>
            <span v-else>
              Continue to Payment
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
              </svg>
            </span>
          </button>
        </div>

        <!-- ════════════════════════════════
             GATEWAY PANEL
        ════════════════════════════════ -->
        <div v-if="screen === 'gateway'" class="form-card">
          <div class="card-header">
            <div class="step-badge bank-badge">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 21h18M5 21V7l8-4 8 4v14M9 9h1m4 0h1m-6 4h1m4 0h1m-6 4h1m4 0h1"/>
              </svg>
            </div>
            <div>
              <h2 class="card-title">
                {{ sabhaIpg === 'BOC' ? 'Payment Gateway' : sabhaIpg === 'people' ? "Payment Gateway" : 'Online Payment Gateway' }}
              </h2>
              <p class="card-desc">
                <span v-if="!sabhaIpg" class="mode-badge sim-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"/>
                  </svg>
                  Simulation Mode
                </span>
                <span v-else class="mode-badge live-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                  </svg>
                  Secure Payment
                </span>
              </p>
            </div>
          </div>

          <!-- Order Summary -->
          <div class="summary-section">
            <div class="summary-row"><span class="summary-label">Invoice No.</span><span class="summary-value">{{ pendingInvoice }}</span></div>
            <div class="summary-row"><span class="summary-label">Account No.</span><span class="summary-value">{{ accountDetails.accountNumber }}</span></div>
            <div class="summary-row grand-total-row">
              <span class="summary-label">Amount Payable</span>
              <span class="summary-value grand-total-value">LKR {{ formatCurrency(grandTotal) }}</span>
            </div>
          </div>

          <!-- LIVE IPG — BOC -->
          <div v-if="sabhaIpg === 'BOC'" class="ipg-section">
            <div class="info-banner">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <div class="info-text">
                <p>You will be securely redirected to the  payment page.</p>
                <p class="sin-text">ඔබව ආරක්ෂිතව ගෙවීම් පිටුවට හෙළවනු ලැබේ.</p>
              </div>
            </div>
            <button @click="submitBocPayment" class="pay-now-btn w-100" :disabled="isSubmitting">
              <span v-if="isSubmitting" class="loading-text">
                <svg class="spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Redirecting to Payment Page...
              </span>
              <span v-else>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                </svg>
                Pay Now
              </span>
            </button>
          </div>

          <!-- LIVE IPG — PEOPLE'S BANK -->
          <div v-else-if="sabhaIpg === 'people'" class="ipg-section">
            <div class="info-banner">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <div class="info-text">
                <p>You will be securely redirected to the payment page.</p>
              </div>
            </div>
            <button @click="submitPeoplesBankPayment" class="pay-now-btn w-100" :disabled="isSubmitting">
              <span v-if="isSubmitting" class="loading-text">
                <svg class="spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Redirecting to Payment Page..
              </span>
              <span v-else>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                </svg>
                Pay Now
              </span>
            </button>
            <div id="pb-form-response" style="display:none; margin-top: 1.4rem;"></div>
          </div>

          <!-- SIMULATION -->
          <div v-else class="ipg-section">
            <div class="info-banner sim">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"/>
              </svg>
              <div class="info-text">
                <p>No payment gateway is configured for this council yet. Select an outcome to simulate the full payment flow:</p>
              </div>
            </div>
            <div class="sim-actions">
              <button @click="simulatePayment('success')" class="sim-success-btn" :disabled="isSubmitting">
                <span v-if="isSubmitting && simulating === 'success'" class="loading-text">
                  <svg class="spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Processing...
                </span>
                <span v-else>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  Simulate: Payment Successful
                </span>
              </button>
              <button @click="simulatePayment('failed')" class="sim-fail-btn" :disabled="isSubmitting">
                <span v-if="isSubmitting && simulating === 'failed'" class="loading-text">
                  <svg class="spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Processing...
                </span>
                <span v-else>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                  Simulate: Payment Failed / Cancelled
                </span>
              </button>
            </div>
          </div>

          <!-- Gateway error -->
          <div v-if="gwError" class="error-banner" style="margin-top: 1.2rem;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
            {{ gwError }}
          </div>

          <!-- Secure note -->
          <div class="secure-note">
            <div class="brand-row">
              <img src="../../assets/images/visa-logo-png-2017.png" alt="Visa" class="brand-logo" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" class="brand-logo" />
            </div>
            <p class="secure-text">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
              </svg>
              256-bit SSL encrypted
              <span class="dot">•</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
              </svg>
              PCI DSS compliant
            </p>
          </div>
        </div>
        <!-- end gateway panel -->

      </div>

    </div>
  </div>
</template>


<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { mapState } from "vuex";
const BANK_FEE_RATE_PEOPLE = 0.01;           // 1% — People's Bank
const BANK_FEE_RATE_BOC    = (100 / (100 - 1)) - 1; // BOC inclusive rate (same formula as legacy)

export default {
  name: "WaterBillOnlinePay",
  data() {
    return {
      Nic:"",
      sbCode:"",
      screen: "main",       // 'main' | 'confirm' | 'gateway' | 'success' | 'failed'
      isSubmitting: false,
      simulating: null,     // 'success' | 'failed'
      checkoutStarted: false,
      certified: false,
      lockedPaymentAmount: 0,
      bankFee: 0,
      grandTotal: 0,
      enteredPaymentAmount: 0,
      payError: "",
      gwError: "",          // gateway-level errors (BOC redirect failures etc.)
      pendingInvoice: "",

      // ── Sabha / IPG config (populated from route query or session) ──
      sabhaCode: "",
      sabhaIpg: "",         // 'BOC' | 'people' | '' (empty = simulation)

      accountDetails: {
        accountId: "",
        accountNumber: "",
        customerNic: "",
        customerName: "",
        sabhaCode: "",
        contactNo: "",
        address: "",
        totalOutstanding: 0,
        billingDate: "",
        period: "",
        readings: { previous: 0, current: 0, consumed: 0 }
      },
      requiredAmounts: { fine: 0, arrears: 0, current: 0 },
      breakdownInputs:  { fine: 0, arrears: 0, current: 0, excess: 0 },

      result: {
        invoiceNumber: "",
        accountNumber: "",
        paymentAmount: 0,
        remainingBalance: null,
        errorMsg: ""
      }
    };
  },
    created() {
           
            this.getSessionData();
        },
 computed : {
            ...mapState(["user"]),
           
        },
  mounted() {
    const q = this.$route.query;
    if (q.accNo) {
      this.accountDetails.accountId      = q.accountId    || "";
      this.accountDetails.accountNumber  = q.accNo;
      this.accountDetails.customerNic    = q.customerNic  || "";
      this.accountDetails.customerName   = q.customerName || "";
      this.accountDetails.sabhaCode      = q.sabhaCode    || "";
      this.accountDetails.contactNo      = q.contactNo    || "";
      this.accountDetails.address        = q.address      || "";
      this.accountDetails.billingDate    = this.formatDate(q.bDate);
      this.accountDetails.period         = `${this.formatDate(q.pFrom)} to ${this.formatDate(q.pTo)}`;
      this.accountDetails.readings.previous = q.pRead || 0;
      this.accountDetails.readings.current  = q.cRead || 0;
      this.accountDetails.readings.consumed = q.units || 0;

      this.sabhaCode = q.sabhaCode || "";

      const currentVal        = parseFloat(q.monthly)        || 0;
      const currentBalanceVal = parseFloat(q.currentBalance);
      const totalDueVal       = Number.isFinite(currentBalanceVal)
        ? currentBalanceVal
        : ((parseFloat(q.arrears) || 0) + currentVal);

      this.requiredAmounts.current = totalDueVal > 0 ? Math.min(currentVal, totalDueVal) : 0;
      this.requiredAmounts.arrears = totalDueVal > 0
        ? Math.max(totalDueVal - this.requiredAmounts.current, 0)
        : 0;
      this.requiredAmounts.fine    = 0;
      this.accountDetails.totalOutstanding = totalDueVal;

      if (totalDueVal > 0) {
        this.enteredPaymentAmount = totalDueVal;
        this.autoDistributePayment();
      }

      // ── Load Sabha IPG config ──
      this.loadSabhaIpg();
    }
  },

  methods: {
    // ── Helpers ────────────────────────────────────────────────────────────
...mapMutations(["setUser"]),
         async MatchUser(nic) {
               let data = await axios.get('/customersdata/' + nic);
               this.matchUser = data.data;
         },
     
        
         async getSessionData(){
         const data=JSON.parse(sessionStorage.getItem('Userdata'));
         if(data){
            this.Nic=data.Unic;
            this.sbCode=data.Usabha;
         }
            await this.MatchUser(this.Nic);
            this.setUser(this.matchUser);
                       
         },
    formatDate(v) {
      if (!v || v === "undefined") return "N/A";
      try { return new Date(v).toISOString().split("T")[0]; } catch { return v; }
    },

    formattedToday() {
      const d = new Date();
      const options = { timeZone: "Asia/Colombo", year: "numeric", month: "2-digit", day: "2-digit" };
      const parts = new Intl.DateTimeFormat("en-CA", options).formatToParts(d);
      const p = Object.fromEntries(parts.map(x => [x.type, x.value]));
      return `${p.year}-${p.month}-${p.day}`;
    },

    autoDistributePayment() {
      let r = this.enteredPaymentAmount;
      this.breakdownInputs.fine    = Math.min(r, this.requiredAmounts.fine);    r -= this.breakdownInputs.fine;
      this.breakdownInputs.arrears = Math.min(r, this.requiredAmounts.arrears); r -= this.breakdownInputs.arrears;
      this.breakdownInputs.current = Math.min(r, this.requiredAmounts.current); r -= this.breakdownInputs.current;
      this.breakdownInputs.excess  = r > 0 ? r : 0;
    },

    formatCurrency(val) {
      return parseFloat(val || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
    },

    // ── Fetch Sabha IPG type ────────────────────────────────────────────────
    async loadSabhaIpg() {
      if (!this.sabhaCode) return;
      try {
        const res = await axios.get(`/PraSabhadata/${this.sabhaCode}`);
        const sabhaData = res.data;
        if (sabhaData && sabhaData[0]) {
          this.sabhaIpg = sabhaData[0].saba_ipg || "";
        }
      } catch (e) {
        console.warn("Could not load Sabha IPG config:", e);
      }
    },

    // ── Checkout flow ───────────────────────────────────────────────────────
    startCheckout() {
      if (this.enteredPaymentAmount <= 0 || this.isSubmitting) return;
      this.lockedPaymentAmount = Number(this.enteredPaymentAmount || 0);

      // Use the correct fee rate depending on IPG
      const feeRate = this.sabhaIpg === "BOC" ? BANK_FEE_RATE_BOC : BANK_FEE_RATE_PEOPLE;
      this.bankFee    = parseFloat((this.lockedPaymentAmount * feeRate).toFixed(2));
      this.grandTotal = parseFloat((this.lockedPaymentAmount + this.bankFee).toFixed(2));

      this.checkoutStarted = true;
      this.certified  = false;
      this.payError   = "";
      this.screen     = "confirm";
    },

    resetCheckout() {
      if (this.isSubmitting) return;
      this.checkoutStarted = false;
      this.certified  = false;
      this.payError   = "";
      this.gwError    = "";
      this.screen     = "main";
    },

    // ── Step 1: Initiate invoice, then show gateway panel ──────────────────
    async initiateAndShowGateway() {
      if (!this.certified || this.isSubmitting) return;

      this.payError     = "";
      this.gwError      = "";
      this.isSubmitting = true;

      try {
        const breakdowns = [
          { category: "Fines",        amount: this.breakdownInputs.fine    },
          { category: "Arrears",      amount: this.breakdownInputs.arrears },
          { category: "Current Bill", amount: this.breakdownInputs.current },
          { category: "Excess",       amount: this.breakdownInputs.excess  }
        ].filter(item => Number(item.amount || 0) > 0);

        const res = await axios.post("/water_bill/online-payment/initiate", {
          account_id:     this.accountDetails.accountId,
          account_number: this.accountDetails.accountNumber,
          payment_amount: this.lockedPaymentAmount,
          breakdowns,
          paymonth: new Date().toISOString().slice(0, 7)
        });

        const invoiceNumber = res?.data?.data?.invoiceNumber;
        if (!invoiceNumber) throw new Error("Invoice number was not generated.");
        this.pendingInvoice = invoiceNumber;

        await axios.post("/onlinepaymenttemp/", {
          online_cus_nic:     this.Nic,
          online_sabha_code:  this.accountDetails.sabhaCode,
          online_invoice_num: this.pendingInvoice,
          online_pay_amount:  this.lockedPaymentAmount,
          online_pay_month:   new Date().getMonth() + 1,
          online_pay_year:    new Date().getFullYear(),
          online_pay_des:     `Water Bill – User NIC ${this.accountDetails.accountNumber}`,
          pay_type:           "water",
          vote:               res.data.data.sbRateHead ?? "",
          online_pay_date:    this.formattedToday(),
        });

        this.screen = "gateway";

      } catch (error) {
        this.payError = error?.response?.data?.message
          || error?.message
          || "Could not create payment session. Please try again.";
      } finally {
        this.isSubmitting = false;
      }
    },

    // ── Step 2a: BOC live redirect ──────────────────────────────────────────
    async submitBocPayment() {
      if (this.isSubmitting) return;

      this.gwError      = "";
      this.isSubmitting = true;
      try {
        const backendUrl =
          window.sessionStorage.getItem("backendUrl") || "https://elgservices.com.lk/api";
          localStorage.setItem(
              "token",
              sessionStorage.getItem("token")
            );

            localStorage.setItem(
              "user",
              sessionStorage.getItem("user")
            );

        const bocRes = await axios.post(`${backendUrl}/bocpay/`, {
          boc_sid:         this.sabhaCode,
          boc_paytype:     "water",
          boc_amount:      this.lockedPaymentAmount,
          boc_grandamount: this.grandTotal,
          boc_cus_nic:     this.Nic,
          boc_invoice:     this.pendingInvoice,
          boc_remarks:     `Water Bill – Acc ${this.accountDetails.accountNumber}`,
          country:         "LKA",
          street:          this.accountDetails.address || "N/A",
          street2:         this.sabhaCode,
          city:            "N/A",
          state:           "N/A",
          zip:             "00000"
        });

        const sessionId = bocRes?.data?.sessionid;
        if (!sessionId) throw new Error("BOC session ID was not returned.");

        // // ── Uncomment for production gateway:
        // window.location.href =
        //   `https://bankofceylon.gateway.mastercard.com/checkout/pay/${sessionId}?checkoutVersion=1.0.0`;

        // ── Test gateway:
        window.location.href =
          `https://test-bankofceylon.mtf.gateway.mastercard.com/checkout/pay/${sessionId}?checkoutVersion=1.0.0`;

      } catch (error) {
        this.gwError = error?.response?.data?.message
          || error?.message
          || "Could not connect to Bank of Ceylon. Please try again.";
      } finally {
        this.isSubmitting = false;
      }
    },

    // ── Step 2b: People's Bank live redirect (extend as needed) ───────────
    async submitPeoplesBankPayment() {
      if (this.isSubmitting) return;
      this.gwError      = "";
      this.isSubmitting = true;
      try {
        const backendUrl =
          window.sessionStorage.getItem("backendUrl") || "https://elgservices.com.lk/api";

        const res = await axios.post(`${backendUrl}/process-payment`, {
          mid:                       this.sabhaCode,
          paytype:                   "water",
          amount:                    this.grandTotal,
          referenceNumber:           this.pendingInvoice,
          email:                     "",
          bill_to_forename:          this.Nic,
          bill_to_surname:           this.accountDetails.customerName,
          bill_to_address_line1:     this.accountDetails.address || "N/A",
          bill_to_address_city:      "water",
          bill_to_address_state:     "N/A",
          bill_to_address_postal_code: "00000",
          bill_to_address_country:   "LK"
        });

        // People's Bank typically returns an HTML form to inject — handle per your integration
        if (res?.data) {
          const target = document.getElementById("pb-form-response");
          if (target) {
            target.innerHTML = res.data;
            target.style.display = "block";
          }
        }
      } catch (error) {
        this.gwError = error?.response?.data?.message
          || error?.message
          || "Could not connect to People's Bank. Please try again.";
      } finally {
        this.isSubmitting = false;
      }
    },

    // ── Step 2c: Simulation (no IPG configured) ────────────────────────────
    async simulatePayment(outcome) {
      if (this.isSubmitting) return;
      this.simulating   = outcome;
      this.isSubmitting = true;
      try {
        const completeRes = await axios.post("/water_bill/online-payment/complete", {
          invoice_number:    this.pendingInvoice,
          gateway_status:    outcome,
          gateway_reference: `SIM-${outcome.toUpperCase()}-${Date.now()}`
        });

        if (outcome === "success" && completeRes?.data?.status === "success") {
          const d = completeRes.data.data || {};
          this.result.invoiceNumber    = this.pendingInvoice;
          this.result.accountNumber    = d.accountNumber    || this.accountDetails.accountNumber;
          this.result.paymentAmount    = d.paymentAmount    || this.lockedPaymentAmount;
          this.result.remainingBalance = d.remainingBalance ?? null;
          this.screen = "success";
        } else {
          this.result.errorMsg = outcome === "failed"
            ? "Payment was declined by the gateway. No amount has been charged."
            : (completeRes?.data?.message || "Payment could not be finalised.");
          this.screen = "failed";
        }
      } catch (error) {
        this.result.errorMsg = error?.response?.data?.message
          || error?.message
          || "An unexpected error occurred.";
        this.screen = "failed";
      } finally {
        this.isSubmitting = false;
        this.simulating   = null;
      }
    },

    // ── Navigation ─────────────────────────────────────────────────────────
    viewReceipt() {
      this.$router.push(`/water-bill-receipt/${encodeURIComponent(this.result.invoiceNumber)}`);
    },

    payAnother() {
      this.screen               = "main";
      this.checkoutStarted      = false;
      this.certified            = false;
      this.enteredPaymentAmount = 0;
      this.lockedPaymentAmount  = 0;
      this.bankFee              = 0;
      this.grandTotal           = 0;
      this.pendingInvoice       = "";
      this.payError             = "";
      this.gwError              = "";
      this.result               = { invoiceNumber: "", accountNumber: "", paymentAmount: 0, remainingBalance: null, errorMsg: "" };
      this.$router.push("/water_bill_landing");
    },

    tryAgain() {
      this.screen          = "confirm";
      this.result.errorMsg = "";
      this.gwError         = "";
    }
  }
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

/* ── Page ── */
.pay-page {
  min-height: 100vh;
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  padding: 2rem 1.5rem 4rem;
}
.page-body { max-width: 720px; margin: 0 auto; }

/* ── Page Header ── */
.page-header {
  display: flex; align-items: flex-start;
  margin-bottom: 1.6rem;
}
.header-left { display: flex; align-items: flex-start; gap: 1.4rem; }
.header-bar {
  width: 5px; min-height: 72px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 4px;
}
.breadcrumb-label { font-size: 1.2rem; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: #9a6652; margin: 0 0 0.3rem; }
.page-title { font-family: 'DM Serif Display', serif; font-size: 2.6rem; color: #1c0f0a; margin: 0 0 0.3rem; }
.page-subtitle { font-size: 1.3rem; color: #9a8070; margin: 0; }

/* ── Cards ── */
.form-card {
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 1.2rem; padding: 2rem 2.2rem;
  box-shadow: 0 1px 4px rgba(100,50,30,0.06);
  margin-bottom: 1.6rem;
}
.card-header {
  display: flex; align-items: center; gap: 1.4rem;
  margin-bottom: 1.8rem; padding-bottom: 1.4rem; border-bottom: 1px solid #f0e6de;
}
.step-badge {
  width: 3.8rem; height: 3.8rem; border-radius: 50%;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.step-badge svg { width: 1.8rem; height: 1.8rem; stroke: #fff; }
.step-badge.bank-badge { background: linear-gradient(135deg, #1c0f0a, #4a3028); }
.card-title { font-family: 'DM Serif Display', serif; font-size: 1.75rem; color: #1c0f0a; margin: 0 0 0.15rem; }
.card-desc  { font-size: 1.25rem; color: #9a8070; margin: 0; }

/* ── Total Due Card ── */
.total-due-card { text-align: center; padding: 1.8rem; }
.due-label {
  font-size: 1.15rem; font-weight: 700; letter-spacing: 0.1em;
  text-transform: uppercase; color: #9a6652;
}
.due-amount {
  font-family: 'DM Serif Display', serif; font-size: 3rem;
  color: #1c0f0a; margin: 0.4rem 0 0;
}

/* ── Detail Grid ── */
.detail-grid {
  display: grid; grid-template-columns: 1fr 1fr; gap: 1.2rem; margin-bottom: 1.4rem;
}
.detail-item {
  background: #faf8f6; border: 1px solid #f0e6de;
  border-radius: 0.7rem; padding: 1rem 1.2rem;
  display: flex; flex-direction: column; gap: 0.4rem;
}
.detail-label {
  display: flex; align-items: center; gap: 0.4rem;
  font-size: 1.1rem; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.05em; color: #9a6652;
}
.detail-label svg { width: 1.3rem; height: 1.3rem; stroke: #c2440a; flex-shrink: 0; }
.detail-value { font-size: 1.35rem; color: #1c0f0a; font-weight: 600; }
.detail-value.small-text { font-size: 1.15rem; }

/* Readings */
.readings-row {
  display: flex; align-items: center; justify-content: space-between;
  background: #faf8f6; border: 1px solid #f0e6de;
  border-radius: 0.9rem; padding: 1.2rem 1.4rem;
}
.reading-item { flex: 1; text-align: center; display: flex; flex-direction: column; gap: 0.3rem; }
.reading-divider { width: 1px; height: 2.2rem; background: #e5ddd5; }
.reading-divider.main { width: 2px; background: #d4c8be; }
.reading-item.highlight .detail-value.consumed { color: #c2440a; font-size: 1.6rem; font-family: 'DM Serif Display', serif; }
.reading-item.highlight .detail-label { color: #c2440a; justify-content: center; }
.detail-value.consumed { font-weight: 700; }

/* ── Amount Input ── */
.amount-input-wrap { position: relative; display: flex; align-items: center; margin-bottom: 1.4rem; }
.currency-tag {
  position: absolute; left: 1.4rem;
  font-weight: 700; color: #c2440a; font-size: 1.3rem; pointer-events: none;
}
.amount-input {
  width: 100%; padding: 1.4rem 1.4rem 1.4rem 5.2rem;
  font-size: 2.4rem; font-weight: 700; font-family: 'DM Sans', sans-serif;
  border: 2px solid #e5ddd5; border-radius: 0.9rem;
  background: #faf8f6; color: #1c0f0a; transition: all 0.2s;
}
.amount-input:focus { outline: none; border-color: #c2440a; background: #fff; box-shadow: 0 0 0 3px rgba(194,68,10,0.09); }
.amount-input:disabled { opacity: 0.7; cursor: not-allowed; }

/* ── Breakdown ── */
.breakdown-box {
  background: #faf8f6; border: 1px dashed #d4c8be;
  border-radius: 1rem; padding: 1.6rem; margin-bottom: 1.4rem;
}
.breakdown-title {
  text-align: center; font-size: 1.1rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em; color: #9a8070; margin: 0 0 1rem;
}
.allocation-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; text-align: center; }
.alloc-item { border-right: 1px solid #e5ddd5; padding: 0.5rem; }
.alloc-item.no-border { border-right: none; }
.alloc-label { display: block; font-size: 1.1rem; font-weight: 600; color: #9a8070; margin-bottom: 0.3rem; }
.alloc-val { font-weight: 700; font-size: 1.3rem; }
.fine-text { color: #b91c1c; }
.arrears-text { color: #b45309; }
.success-text { color: #166534; }
.excess-pill {
  margin-top: 1rem; background: #f0ebe3; color: #4a3028;
  padding: 0.8rem; border-radius: 0.6rem; text-align: center; font-size: 1.2rem;
}

/* ── Buttons ── */
.submit-btn, .pay-now-btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 0.7rem;
  padding: 1.05rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border: none; border-radius: 0.9rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.5rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 16px rgba(124,45,18,0.28); transition: all 0.2s;
}
.submit-btn svg, .pay-now-btn svg { width: 1.8rem; height: 1.8rem; }
.submit-btn:hover:not(:disabled), .pay-now-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(124,45,18,0.38); }
.submit-btn:disabled, .pay-now-btn:disabled {
  background: #e5ddd5; color: #b0a09a; box-shadow: none; cursor: not-allowed;
}
.pay-now-btn {
  background: linear-gradient(135deg, #0f766e, #0d9488);
  box-shadow: 0 4px 16px rgba(13,148,136,0.28);
}
.pay-now-btn:hover:not(:disabled) { box-shadow: 0 8px 24px rgba(13,148,136,0.38); }
.w-100 { width: 100%; }

/* Loading */
.loading-text { display: inline-flex; align-items: center; gap: 0.7rem; }
.spin { width: 1.8rem; height: 1.8rem; animation: spin 0.8s linear infinite; }
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

/* ── Confirm Header ── */
.confirm-header-flex {
  display: flex; align-items: flex-start; justify-content: space-between; flex: 1; gap: 1rem;
}
.edit-amount-btn {
  border: none; background: transparent; color: #c2440a;
  font-weight: 700; font-size: 1.2rem; cursor: pointer; white-space: nowrap;
}
.edit-amount-btn:hover { text-decoration: underline; }
.edit-amount-btn:disabled { color: #d4c8be; cursor: not-allowed; }

/* ── Summary Section ── */
.summary-section {
  background: #faf8f6; border: 1px solid #f0e6de;
  border-radius: 0.9rem; padding: 1rem 1.4rem; margin-bottom: 1.4rem;
}
.summary-row { display: flex; justify-content: space-between; padding: 0.6rem 0; border-bottom: 1px solid #f0e6de; }
.summary-row:last-child { border-bottom: none; }
.summary-label { font-size: 1.25rem; color: #4a3028; }
.summary-value { font-size: 1.3rem; color: #1c0f0a; font-variant-numeric: tabular-nums; }
.summary-value.muted { color: #9a8070; }
.grand-total-row { padding-top: 1rem; }
.grand-total-row .summary-label { font-weight: 700; }
.grand-total-value { font-family: 'DM Serif Display', serif; font-size: 1.7rem; color: #7c2d12; font-weight: 700; }

/* ── Certify ── */
.certify-label { display: flex; align-items: flex-start; gap: 1rem; cursor: pointer; margin-bottom: 1.4rem; }
.custom-checkbox {
  width: 2.2rem; height: 2.2rem; flex-shrink: 0; margin-top: 0.1rem;
  border: 2px solid #e5ddd5; border-radius: 0.4rem; background: #faf8f6;
  display: flex; align-items: center; justify-content: center; transition: all 0.2s;
}
.custom-checkbox.checked { background: linear-gradient(135deg, #7c2d12, #c2440a); border-color: transparent; }
.custom-checkbox svg { width: 1.4rem; height: 1.4rem; stroke: #fff; }
.certify-text { font-size: 1.3rem; color: #4a3028; line-height: 1.6; }
.certify-text em { font-size: 1.15rem; color: #9a8070; font-style: normal; }

/* ── Error ── */
.error-banner {
  display: flex; align-items: center; gap: 0.8rem;
  background: #fef2f2; border: 1px solid #fca5a5;
  border-radius: 0.7rem; padding: 1rem 1.2rem; margin-bottom: 1.4rem;
  font-size: 1.25rem; color: #991b1b;
}
.error-banner svg { width: 1.6rem; height: 1.6rem; stroke: #dc2626; flex-shrink: 0; }

/* ── Gateway: Mode badges & info ── */
.mode-badge { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 1.1rem; font-weight: 700; padding: 0.2rem 0.8rem; border-radius: 99px; }
.mode-badge svg { width: 1.2rem; height: 1.2rem; }
.sim-badge  { background: #fef9c3; color: #92400e; border: 1px solid #fde68a; }
.live-badge { background: #dcfce7; color: #166534; border: 1px solid #bbf7d0; }

.info-banner {
  display: flex; gap: 1rem; align-items: flex-start;
  background: #fdf8f0; border: 1px solid #f0ddc8;
  border-radius: 0.9rem; padding: 1.2rem 1.4rem; margin-bottom: 1.4rem;
}
.info-banner.sim { background: #fffbeb; border-color: #fde68a; }
.info-banner svg { width: 2rem; height: 2rem; stroke: #c2440a; flex-shrink: 0; margin-top: 0.05rem; }
.info-banner.sim svg { stroke: #b45309; }
.info-text p { font-size: 1.25rem; color: #4a3028; margin: 0 0 0.4rem; line-height: 1.6; }
.info-text p:last-child { margin: 0; }
.sin-text { color: #7c5a48 !important; font-style: italic; }

/* IPG Section */
.ipg-section { display: flex; flex-direction: column; }

/* Simulation buttons */
.sim-actions { display: flex; flex-direction: column; gap: 1rem; }
.sim-success-btn, .sim-fail-btn {
  width: 100%; padding: 1.05rem; border: none; border-radius: 0.9rem;
  font-size: 1.4rem; font-weight: 700; cursor: pointer; transition: all 0.2s;
  display: flex; align-items: center; justify-content: center; gap: 0.7rem;
}
.sim-success-btn svg, .sim-fail-btn svg { width: 1.7rem; height: 1.7rem; }
.sim-success-btn {
  background: linear-gradient(135deg, #0f766e, #059669); color: #fff;
  box-shadow: 0 4px 16px rgba(5,150,105,0.25);
}
.sim-success-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(5,150,105,0.35); }
.sim-success-btn:disabled { background: #d1fae5; color: #6ee7b7; box-shadow: none; cursor: not-allowed; }
.sim-fail-btn {
  background: linear-gradient(135deg, #dc2626, #b91c1c); color: #fff;
  box-shadow: 0 4px 16px rgba(220,38,38,0.22);
}
.sim-fail-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(220,38,38,0.35); }
.sim-fail-btn:disabled { background: #fecaca; color: #fca5a5; box-shadow: none; cursor: not-allowed; }

/* Secure note */
.secure-note { margin-top: 1.6rem; text-align: center; }
.brand-row { display: flex; align-items: center; justify-content: center; gap: 1.6rem; }
.brand-logo { height: 2.8rem; opacity: 0.75; }
.secure-text {
  display: flex; align-items: center; justify-content: center; gap: 0.5rem;
  flex-wrap: wrap; margin-top: 0.7rem; font-size: 1.1rem; color: #9a8070;
}
.secure-text svg { width: 1.4rem; height: 1.4rem; stroke: #9a8070; }
.secure-text .dot { color: #d4c8be; }

/* ── Status (Success/Failed) Cards ── */
.status-card { text-align: center; }
.status-icon {
  width: 7rem; height: 7rem; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1.6rem;
}
.status-icon svg { width: 3.5rem; height: 3.5rem; stroke: #fff; }
.success-icon { background: linear-gradient(135deg, #0f766e, #059669); }
.fail-icon { background: linear-gradient(135deg, #dc2626, #b91c1c); }
.status-title { font-family: 'DM Serif Display', serif; font-size: 2.4rem; color: #1c0f0a; margin: 0 0 0.3rem; }
.status-subtitle { font-size: 1.3rem; color: #9a8070; margin: 0 0 1.8rem; }

.receipt-summary {
  background: #faf8f6; border: 1px solid #f0e6de;
  border-radius: 1rem; padding: 1.2rem 1.6rem; text-align: left; margin-bottom: 1.6rem;
}
.rs-row { display: flex; justify-content: space-between; padding: 0.7rem 0; border-bottom: 1px solid #f0e6de; }
.rs-row:last-child { border-bottom: none; }
.rs-label { font-size: 1.1rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: #9a6652; }
.rs-val { font-size: 1.3rem; color: #1c0f0a; }
.rs-val.bold { font-weight: 700; }

.sms-note {
  display: flex; align-items: center; justify-content: center; gap: 0.6rem;
  font-size: 1.2rem; color: #9a8070; margin-bottom: 1.8rem;
}
.sms-note svg { width: 1.6rem; height: 1.6rem; stroke: #0f766e; flex-shrink: 0; }

.action-stack { display: flex; flex-direction: column; gap: 1rem; }
.btn-primary-action {
  display: inline-flex; align-items: center; justify-content: center; gap: 0.7rem;
  padding: 1.05rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border: none; border-radius: 0.9rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.45rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 16px rgba(124,45,18,0.28); transition: all 0.2s;
}
.btn-primary-action svg { width: 1.8rem; height: 1.8rem; }
.btn-primary-action:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(124,45,18,0.38); }
.btn-outline-action {
  display: inline-flex; align-items: center; justify-content: center; gap: 0.7rem;
  padding: 1rem;
  background: #fff; color: #7c2d12; border: 1.5px solid #e5ddd5; border-radius: 0.9rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.35rem; font-weight: 600;
  cursor: pointer; transition: all 0.2s;
}
.btn-outline-action svg { width: 1.6rem; height: 1.6rem; }
.btn-outline-action:hover { background: #faf8f6; border-color: #c2440a; color: #c2440a; }

/* ── Responsive ── */
@media (max-width: 768px) {
  .pay-page { padding: 1.5rem 1rem 3rem; }
  .page-title { font-size: 2rem; }
  .form-card { padding: 1.5rem; }
  .detail-grid { grid-template-columns: 1fr; }
  .readings-row { flex-wrap: wrap; gap: 1rem; }
  .reading-divider, .reading-divider.main { display: none; }
  .reading-item { flex: 1 1 40%; }
  .reading-item.highlight { flex: 1 1 100%; border-top: 1px solid #e5ddd5; padding-top: 0.8rem; }
  .allocation-grid { grid-template-columns: 1fr; }
  .alloc-item { border-right: none; border-bottom: 1px solid #e5ddd5; padding-bottom: 0.8rem; }
  .alloc-item.no-border { border-bottom: none; }
  .amount-input { font-size: 1.8rem; padding-left: 4.5rem; }
  .due-amount { font-size: 2.2rem; }
}
</style>